import React from "react";
import { RankListLiterals } from "../../../../application/domain/customer-review/customer-review";

const StarIcon = () => {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
      <mask id="path-1-inside-1_1387_857" fill="white">
        <path d="M5.70039 0.732824C6.0578 -0.0420474 7.15909 -0.0420474 7.5165 0.732824L8.63109 3.14924C8.77676 3.46505 9.07604 3.68249 9.42141 3.72344L12.064 4.03676C12.9114 4.13723 13.2517 5.18462 12.6252 5.76399L10.6715 7.57074C10.4161 7.80686 10.3018 8.15869 10.3696 8.49981L10.8882 11.1099C11.0545 11.9468 10.1636 12.5942 9.41894 12.1774L7.09689 10.8776C6.79342 10.7077 6.42348 10.7077 6.12001 10.8776L3.79795 12.1774C3.05334 12.5942 2.16238 11.9468 2.32868 11.1099L2.8473 8.49981C2.91508 8.1587 2.80076 7.80686 2.54543 7.57074L0.591702 5.76399C-0.0347981 5.18462 0.305518 4.13723 1.15291 4.03676L3.79549 3.72344C4.14085 3.68249 4.44014 3.46505 4.5858 3.14924L5.70039 0.732824Z" />
      </mask>
      <path
        d="M5.70039 0.732824C6.0578 -0.0420474 7.15909 -0.0420474 7.5165 0.732824L8.63109 3.14924C8.77676 3.46505 9.07604 3.68249 9.42141 3.72344L12.064 4.03676C12.9114 4.13723 13.2517 5.18462 12.6252 5.76399L10.6715 7.57074C10.4161 7.80686 10.3018 8.15869 10.3696 8.49981L10.8882 11.1099C11.0545 11.9468 10.1636 12.5942 9.41894 12.1774L7.09689 10.8776C6.79342 10.7077 6.42348 10.7077 6.12001 10.8776L3.79795 12.1774C3.05334 12.5942 2.16238 11.9468 2.32868 11.1099L2.8473 8.49981C2.91508 8.1587 2.80076 7.80686 2.54543 7.57074L0.591702 5.76399C-0.0347981 5.18462 0.305518 4.13723 1.15291 4.03676L3.79549 3.72344C4.14085 3.68249 4.44014 3.46505 4.5858 3.14924L5.70039 0.732824Z"
        fill="#353EBD"
        stroke="#353EBD"
        mask="url(#path-1-inside-1_1387_857)"
      />
    </svg>
  );
};

export const ReviewStars: React.FC<{ rank: RankListLiterals }> = ({ rank }) => {
  return (
    <div className="review-stars-container">
      {[...Array(rank)].map((_, index) => {
        return <StarIcon key={`${rank}-${index}`} />;
      })}
    </div>
  );
};
